const DPPProductTypes = {
  FETCH_DOCUMENT_LIST: 'FETCH_DOCUMENT_LIST',
  CLEAR_DOCUMENT_REDUCER: 'CLEAR_DOCUMENT_REDUCER',
  FETCH_BREAD_CRUMB_DATA: 'FETCH_BREAD_CRUMB_DATA',
  GET_DOCUEMNT_BY_ID: 'GET_DOCUMENT_BY_ID',
  GET_FOLDER_LIST: 'GET_FOLDER_LIST',
  GET_SUPPLIER_LIST: 'GET_SUPPLIER_LIST',
};

export default DPPProductTypes;
